/* aw-reveal.js — blokken komen op als je ernaartoe scrollt (alleen telefoon).
 *
 * Gevraagd voor de gender-split en het verhaalblok: "simpele mooie animaties".
 * Gekozen: opkomen én 16px omhoog schuiven, met 80ms tussen de onderdelen.
 * Dezelfde tijdcurve als de hero, zodat de pagina één beweging spreekt.
 *
 * DE BEGINTOESTAND STAAT IN CSS, niet hier. Zet je hem in het script, dan heeft
 * de bezoeker het blok al een frame vol in beeld gezien voordat `defer` toekomt
 * aan het verbergen — precies de flikkering die je wilt vermijden. Dat staat zo
 * ook in aw-hero.js.
 *
 * En daarom een VANGNET: als er iets misgaat met dit script zou de inhoud
 * anders onzichtbaar blijven. Na 4 seconden gaat alles hoe dan ook aan, en als
 * de browser geen IntersectionObserver heeft meteen.
 */
(() => {
  const KLAAR = 'aw-reveal--klaar';
  const blokken = () => document.querySelectorAll('.aw-gender, .aw-story');

  const toon = (el) => el.classList.add(KLAAR);
  const allesTonen = () => blokken().forEach(toon);

  function start() {
    if (!('IntersectionObserver' in window)) { allesTonen(); return; }

    const kijker = new IntersectionObserver((rijen, zelf) => {
      for (const r of rijen) {
        if (!r.isIntersecting) continue;
        toon(r.target);
        zelf.unobserve(r.target);   // één keer; niet opnieuw bij terugscrollen
      }
    }, { threshold: 0.15 });

    blokken().forEach((b) => {
      /* Staat het blok al in beeld bij het laden (korte pagina, of je komt
         terug met de terugknop), dan hoeft er niets te bewegen. */
      const r = b.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.85) { toon(b); return; }
      kijker.observe(b);
    });

    setTimeout(allesTonen, 4000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
